"use client";

export default function BuyMeACoffeeButton() {
  return (
    <>
      {/* Mobile version - small button in bottom right */}
      <div className="fixed right-0 bottom-2 z-40 block sm:hidden">
        <a
          href="https://www.paypal.com/donate/?business=4TJKM4YS2E5GC&no_recurring=1&currency_code=GBP"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/62977a35e01809629f113559.png"
            alt="Donate with PayPal"
            className="h-auto w-30"
          />
        </a>
      </div>

      {/* Desktop version - larger button */}
      <div className="fixed right-0 bottom-0 z-40 hidden sm:block">
        <a
          href="https://www.paypal.com/donate/?business=4TJKM4YS2E5GC&no_recurring=1&currency_code=GBP"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/62977a35e01809629f113559.png"
            alt="Donate with PayPal"
            className="h-[55px]"
          />
        </a>
      </div>
    </>
  );
}
